/**
 * @flow
 * @relayHash 254514da176b1b7993d358bfbdcd4c4b
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type TradeProcurementRendererQueryResponse = {|
  +viewer: ?{| |};
|};
*/


/*
query TradeProcurementRendererQuery(
  $userId: String = ""
  $hasUserId: Boolean = false
  $additionalItemIds: [String]
) {
  viewer {
    ...TradeProcurementContent_viewer
    id
  }
}

fragment TradeProcurementContent_viewer on Viewer {
  ...PurchaseRequestForm_viewer
  ...Success_viewer
  user(userId: $userId) @include(if: $hasUserId) {
    ...PurchaseRequestForm_user
    ...AdditionalDetailsForm_user
    serviceId
    id
  }
}

fragment PurchaseRequestForm_viewer on Viewer {
  ...AddressSelector_viewer
}

fragment Success_viewer on Viewer {
  items(first: 6, itemIds: $additionalItemIds) {
    edges {
      node {
        serviceId
        pdpURL
        firstPhotoWebPath(size: small)
        isInProcurement(userId: $userId) @include(if: $hasUserId)
        id
      }
    }
  }
}

fragment PurchaseRequestForm_user on User {
  ...AddressSelector_user
}

fragment AdditionalDetailsForm_user on User {
  serviceId
}

fragment AddressSelector_user on User {
  serviceId
  firstValidShippingAddress {
    serviceId
    id
  }
  addressBook {
    addressList {
      line2
      sourceId
      displayName
      formattedAddress
      displayCountry
      firstName
      lastName
      line1
      serviceId
      country
      city
      state
      zipCode
      phoneNumber
      validation {
        buyerShipping {
          valid
        }
      }
      id
    }
  }
}

fragment AddressSelector_viewer on Viewer {
  ...AddressForm_viewer
}

fragment AddressForm_viewer on Viewer {
  geography {
    countries {
      name
      abbreviation
    }
    usStates {
      name
      abbreviation
    }
  }
  zipCodeLookUp: zipCode(zipCode: $zipCode, country: $country) @include(if: $canCheckZipCode) {
    city
    state
    id
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "userId",
        "type": "String",
        "defaultValue": ""
      },
      {
        "kind": "LocalArgument",
        "name": "hasUserId",
        "type": "Boolean",
        "defaultValue": false
      },
      {
        "kind": "LocalArgument",
        "name": "additionalItemIds",
        "type": "[String]",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TradeProcurementRendererQuery",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "TradeProcurementContent_viewer",
            "args": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "TradeProcurementRendererQuery",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "userId",
        "type": "String",
        "defaultValue": ""
      },
      {
        "kind": "LocalArgument",
        "name": "hasUserId",
        "type": "Boolean",
        "defaultValue": false
      },
      {
        "kind": "LocalArgument",
        "name": "additionalItemIds",
        "type": "[String]",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "TradeProcurementRendererQuery",
    "operation": "query",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Geography",
            "name": "geography",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "GeographyObject",
                "name": "countries",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "abbreviation",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "GeographyObject",
                "name": "usStates",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "abbreviation",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 6,
                "type": "Int"
              },
              {
                "kind": "Variable",
                "name": "itemIds",
                "variableName": "additionalItemIds",
                "type": "[String]"
              }
            ],
            "concreteType": "ItemsConnection",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "ItemsEdge",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "Item",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "serviceId",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "pdpURL",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "size",
                            "value": "small",
                            "type": "ImageVersionTypeName!"
                          }
                        ],
                        "name": "firstPhotoWebPath",
                        "storageKey": "firstPhotoWebPath{\"size\":\"small\"}"
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "id",
                        "storageKey": null
                      },
                      {
                        "kind": "Condition",
                        "passingValue": true,
                        "condition": "hasUserId",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": [
                              {
                                "kind": "Variable",
                                "name": "userId",
                                "variableName": "userId",
                                "type": "String!"
                              }
                            ],
                            "name": "isInProcurement",
                            "storageKey": null
                          }
                        ]
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasUserId",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "userId",
                    "variableName": "userId",
                    "type": "String!"
                  }
                ],
                "concreteType": "User",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "serviceId",
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "Address",
                    "name": "firstValidShippingAddress",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "serviceId",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "id",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "AddressBook",
                    "name": "addressBook",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "Address",
                        "name": "addressList",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "serviceId",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "line2",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "displayName",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "formattedAddress",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "displayCountry",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "firstName",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "lastName",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "line1",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "sourceId",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "country",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "city",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "state",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "zipCode",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "phoneNumber",
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "args": null,
                            "concreteType": "AddressValidation",
                            "name": "validation",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "args": null,
                                "concreteType": "ValidationResult",
                                "name": "buyerShipping",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "args": null,
                                    "name": "valid",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "id",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "canCheckZipCode",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": "zipCodeLookUp",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "country",
                    "variableName": "country",
                    "type": "String!"
                  },
                  {
                    "kind": "Variable",
                    "name": "zipCode",
                    "variableName": "zipCode",
                    "type": "String!"
                  }
                ],
                "concreteType": "Address",
                "name": "zipCode",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "city",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "state",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "query TradeProcurementRendererQuery(\n  $userId: String = \"\"\n  $hasUserId: Boolean = false\n  $additionalItemIds: [String]\n) {\n  viewer {\n    ...TradeProcurementContent_viewer\n    id\n  }\n}\n\nfragment TradeProcurementContent_viewer on Viewer {\n  ...PurchaseRequestForm_viewer\n  ...Success_viewer\n  user(userId: $userId) @include(if: $hasUserId) {\n    ...PurchaseRequestForm_user\n    ...AdditionalDetailsForm_user\n    serviceId\n    id\n  }\n}\n\nfragment PurchaseRequestForm_viewer on Viewer {\n  ...AddressSelector_viewer\n}\n\nfragment Success_viewer on Viewer {\n  items(first: 6, itemIds: $additionalItemIds) {\n    edges {\n      node {\n        serviceId\n        pdpURL\n        firstPhotoWebPath(size: small)\n        isInProcurement(userId: $userId) @include(if: $hasUserId)\n        id\n      }\n    }\n  }\n}\n\nfragment PurchaseRequestForm_user on User {\n  ...AddressSelector_user\n}\n\nfragment AdditionalDetailsForm_user on User {\n  serviceId\n}\n\nfragment AddressSelector_user on User {\n  serviceId\n  firstValidShippingAddress {\n    serviceId\n    id\n  }\n  addressBook {\n    addressList {\n      line2\n      sourceId\n      displayName\n      formattedAddress\n      displayCountry\n      firstName\n      lastName\n      line1\n      serviceId\n      country\n      city\n      state\n      zipCode\n      phoneNumber\n      validation {\n        buyerShipping {\n          valid\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment AddressSelector_viewer on Viewer {\n  ...AddressForm_viewer\n}\n\nfragment AddressForm_viewer on Viewer {\n  geography {\n    countries {\n      name\n      abbreviation\n    }\n    usStates {\n      name\n      abbreviation\n    }\n  }\n  zipCodeLookUp: zipCode(zipCode: $zipCode, country: $country) @include(if: $canCheckZipCode) {\n    city\n    state\n    id\n  }\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// ./assets/js/global/components/TradeProcurement/__generated__/TradeProcurementRendererQuery.graphql.js